// Admin → People → Guided conversations (28 Oct 2026): what a guide is, New
// guide, and what the Agenda, People and Responses tabs of a guide hold. It
// stays on the list and outlines New guide; it never clicks it, Create guide,
// Invite or Close guide: each one makes, sends or changes something.

import type { Walkthrough } from './types'

export const guidedConversations: Walkthrough = {
  slug: 'guided-conversations',
  title: 'Guided conversations',
  summary:
    'Opens Admin → Guided conversations and shows how a Manager writes a guide, invites people and reads what they said. Nothing is created, sent or changed.',
  added: '2026-10-28',
  steps: [
    {
      page: 'admin-guides',
      feature: 'people/guided-conversations',
      say: 'This is Guided conversations. Each guide is a goal and a list of agenda points. The people you invite work through the points with the agent, and you read what they said.',
    },
    {
      page: 'admin-guides',
      feature: 'people/guided-conversations',
      control: 'New guide',
      say: 'New guide asks for a title and a goal. It names no team: each invited person’s conversation is billed to their own team. A walkthrough never creates a guide for you.',
    },
    {
      page: 'admin-guides',
      feature: 'people/guide-agenda',
      say: 'Open a guide to write its agenda: for each point, the question, what it must find out and when it counts as covered. Set State to Open when it is ready. Agenda (PDF) gives people the questions to read before they start.',
    },
    {
      page: 'admin-guides',
      feature: 'people/guide-invites',
      say: 'On the People tab you invite Platinum users by email. Each one gets a bell notification that opens their own conversation, where the agent ticks off the points and writes notes they can change.',
    },
    {
      page: 'admin-guides',
      feature: 'people/guide-responses',
      say: 'On the Responses tab you read each person’s notes point by point, tag each one for the workshop, and export every response to Excel or Markdown.',
    },
  ],
}
